import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ReservationAdd from "./ReservationAdd";
import ReservationEdit from "./ReservationEdit";
import log from "../lib/log";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import {
  AppBar,
  Toolbar,
  IconButton,
  TableContainer,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  useForkRef,
} from "@mui/material";
import CenterSelect from "./CenterSelect";
import { ko } from "date-fns/locale";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import StaticDatePicker from "@mui/lab/StaticDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import pr from "../lib/pr";
import moment from "moment";
import ReservationClassAdd from "./ReservationClassAdd";
import Chip from "@mui/material/Chip";
import DeleteIcon from "@mui/icons-material/Delete";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import ReservationClassEdit from "./ReservationClassEdit";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const rows = [{ time: "09:00" }];

function Reservation() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(0);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const open = Boolean(anchorEl);
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const [date, setDate] = useState(new Date());
  const [showAdd, setShowAdd] = useState(false); // 예약추가 팝업
  const [showEdit, setShowEdit] = useState(false); // 예약수정 팝업
  const [showClassAdd, setShowClassAdd] = useState(false); // 수업추가 팝업
  const [showClassEdit, setShowClassEdit] = useState(false); // 예약수정 팝업
  const [plan, setPlan] = useState([]); // 수업시간
  const [teacher, setTeacher] = useState([]);
  const [tdate, setTDate] = useState(moment().format("YYYY-MM-DD"));
  const [ptType, setPTType] = useState("");

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 로드데이타
  useEffect(() => {
    if (tcid !== "") {
      load_data();
      load_reservation_class_hour();
    }
  }, [tcid, tdate]);

  // 예약현황
  const load_data = async () => {
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        tcid: tcid,
        tdate: tdate,
      }
    );
    console.log(result.data.rows);
    // gx - 그룹수업, PT_TRAINER - 일반피티 PT_MANAGER - 점장피티
    if (result.data.success === 1) {
      setRows(result.data.rows);
      setTeacher(result.data.teacher);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  const onCloseAddPop = () => {
    setShowAdd(false);
    load_reservation_class_hour();
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    load_data();
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 수업추가
  const onOpenClassAdd = () => {
    setShowClassAdd(true);
  };

  const onCloseClassAdd = () => {
    setShowClassAdd(false);
    load_reservation_class_hour();
  };

  // 수업수정
  const onOpenClassEdit = (params) => {
    const { seq } = params;
    setShowClassEdit(true);
    setSeq(seq);
  };

  const onCloseClassEdit = () => {
    setShowClassEdit(false);
    load_reservation_class_hour();
  };

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onChangeDate = (newDate) => {
    setTDate(moment(newDate).format("YYYY-MM-DD"));
  };

  const load_reservation_class_hour = async () => {
    // 수업시간
    pr("load_reservation_class_hour");
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_class_hour",
      {
        token: token,
        mcd: login.mcd,
        cid: login.cid,
        level: login.level,
        tcid: tcid,
        tdate: tdate,
      }
    );
    if (result.data.success === 1) {
      setPlan(result.data.rows);
      console.log(plan);
    }
  };

  // 예약수정 클릭
  const onChipClick = (i, pt) => {
    setSeq(i);
    setPTType(pt);
    setShowEdit(true);
  };

  // 수업수정
  const onEditClass = (e) => {
    e.preventDefault();
    const seq = e.target.value;
  };

  // 수업삭제
  const onDelClass = (e) => {
    e.preventDefault();
    const seq = e.target.value;
    Swal.fire({
      title: "삭제 하시겠습니까?",
      showCancelButton: true,
      sconfirmButtonText: "예",
      cancelButtonText: "아니오",
      closeOnCalcel: true,
    }).then((result) => {
      if (result.isConfirmed === true) {
        axios
          .post(configState.api + "/gympass_admin/reservation_class_del", {
            seq: seq,
            cid: login.cid,
            mcd: login.mcd,
            token: token,
            level: login.level,
          })
          .then(() => {
            load_reservation_class_hour();
          })
          .catch((e) => alert(e));
      }
    });
  };

  // 수업복사
  const onCopyClass = (x) => {
    Swal.fire({
      title: "선택한 수업을 복사 하시겠습니까?",
      showCancelButton: true,
      showDenyButton: true,
      confirmButtonText: "다음주로 복사",
      denyButtonText: "다음날로 복사",
      cancelButtonText: "취소",
      closeOnCalcel: true,
    })
      .then((result) => {
        // 다음주로 복사
        if (result.isConfirmed === true) {
          axios
            .post(configState.api + "/gympass_admin/copy_teacher_on", {
              seq: x,
              cid: login.cid,
              mcd: login.mcd,
              token: token,
              level: login.level,
              count: 7,
            })
            .then(() => {
              Swal.fire("수업이 다음주로 복사 되었습니다.");
            });
        }

        // 다음날 복사
        if (result.isDenied === true) {
          axios
            .post(configState.api + "/gympass_admin/copy_teacher_on", {
              seq: x,
              cid: login.cid,
              mcd: login.mcd,
              token: token,
              level: login.level,
              count: 1,
            })
            .then(() => {
              Swal.fire("수업이 다음날로 복사 되었습니다.");
            });
        }
      })
      .catch((e) => pr(e));
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <h3 style={{ marginTop: "10px" }}>예약보드</h3>

          <Box sx={{ width: 1350 }}>
            <Box display="flex" alignItems="center" justifyContent="flex-end">
              <Box>
                <CenterSelect
                  tcidParent={tcid}
                  login={login}
                  setTcidParent={setTcid}
                />
              </Box>
              <Box>
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={onOpenClassAdd}
                  sx={{ ml: 0.5 }}
                >
                  수업추가
                </Button>
              </Box>
              <Box>
                {login.level === "500" && (
                  <Button
                    variant="contained"
                    color="primary"
                    startIcon={<AddIcon />}
                    onClick={onOpenAdd}
                    sx={{ ml: 0.5 }}
                  >
                    예약추가
                  </Button>
                )}
              </Box>
            </Box>

            <Box display="flex" mt={1}>
              <Box sx={{ width: 320 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                  <StaticDatePicker
                    name="tdate"
                    displayStaticWrapperAs="desktop"
                    openTo="day"
                    value={tdate}
                    onChange={onChangeDate}
                    renderInput={(params) => <TextField {...params} />}
                  />
                </LocalizationProvider>
              </Box>
              <Box>
                <Box>
                  {/* 수업현황 */}
                  <Box width={1030}>
                    <TableContainer
                      component={Paper}
                      sx={{ mt: 1, height: 350 }}
                    >
                      <Table aria-label="simple table">
                        <TableHead>
                          <TableRow sx={{ background: "#f5f5f5" }}>
                            <TableCell align="center" width={90}>
                              강사명
                            </TableCell>
                            <TableCell align="center" width={100}>
                              구분
                            </TableCell>
                            <TableCell align="center" width={90}>
                              시간
                            </TableCell>
                            <TableCell align="left" width={360}>
                              수업명
                            </TableCell>
                            <TableCell align="center" width={90}>
                              인원
                            </TableCell>
                            <TableCell align="center"></TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {plan.map((item, index) => {
                            return (
                              <TableRow
                                key={index}
                                sx={{
                                  "&:last-child td, &:last-child th": {
                                    border: 0,
                                  },
                                }}
                                style={{
                                  backgroundColor:
                                    item.pt_type === "그룹수업"
                                      ? "rgba(55,198,255,0.2)"
                                      : item.pt_type === "점장PT"
                                      ? "rgba(255,160,122,0.2)"
                                      : "rgba(124,252,0,0.2)",
                                }}
                              >
                                <TableCell scope="row" align="center">
                                  {item.name}
                                </TableCell>
                                <TableCell scope="row" align="center">
                                  {item.pt_type}
                                </TableCell>
                                <TableCell scope="row" align="center">
                                  {item.shour} ~ {item.ehour}
                                </TableCell>
                                <TableCell scope="row" align="left">
                                  {item.class_name}{" "}
                                  {item.class_memo === "" ||
                                  item.class_memo === "null" ? null : (
                                    <> : {item.class_memo}</>
                                  )}
                                </TableCell>
                                <TableCell scope="row" align="center">
                                  {item.max_count}
                                </TableCell>
                                <TableCell
                                  scope="row"
                                  align="center"
                                  display="flex"
                                >
                                  <Button
                                    variant="contained"
                                    onClick={() => {
                                      onCopyClass(item.seq);
                                    }}
                                    sx={{ fontSize: 11 }}
                                    startIcon={<ContentCopyIcon />}
                                  >
                                    복사
                                  </Button>

                                  <Button
                                    variant="contained"
                                    onClick={() => {
                                      onOpenClassEdit({ seq: item.seq });
                                    }}
                                    sx={{ fontSize: 11, ml: 1 }}
                                    startIcon={<ContentCopyIcon />}
                                  >
                                    수정
                                  </Button>

                                  <Button
                                    variant="contained"
                                    value={item.seq}
                                    color="warning"
                                    onClick={onDelClass}
                                    sx={{ fontSize: 11, ml: 1 }}
                                    startIcon={<DeleteIcon />}
                                  >
                                    삭제
                                  </Button>
                                </TableCell>
                              </TableRow>
                            );
                          })}
                          {plan.length === 0 && (
                            <TableRow>
                              <TableCell colSpan="6" align="center">
                                NO DATA
                              </TableCell>
                            </TableRow>
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>

          {/* 예약현황 */}
          <Box mt={3} width={1350}>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow sx={{ background: "#f5f5f5" }}>
                    <TableCell sx={{ width: 80 }} align="center">
                      Hour
                    </TableCell>
                    <TableCell sx={{ width: 230 }} align="center">
                      {teacher.length > 0 ? teacher[0].name : ""}
                    </TableCell>
                    <TableCell sx={{ width: 230 }} align="center">
                      {teacher.length > 1 ? teacher[1].name : ""}
                    </TableCell>
                    <TableCell sx={{ width: 230 }} align="center">
                      {teacher.length > 2 ? teacher[2].name : ""}
                    </TableCell>
                    <TableCell sx={{ width: 230 }} align="center">
                      {teacher.length > 3 ? teacher[3].name : ""}
                    </TableCell>
                    <TableCell sx={{ width: 230 }} align="center">
                      {teacher.length > 4 ? teacher[4].name : ""}
                    </TableCell>
                  </TableRow>
                </TableHead>

                {/* 예약현황 : 데이타 */}
                <TableBody>
                  {rows.map((row, index) => {
                    return (
                      <TableRow
                        key={index}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell scope="row" align="center">
                          {row.hour}
                        </TableCell>
                        {Object.keys(row).map(
                          (key, index) =>
                            key.includes("x") && (
                              <TableCell scope="row" align="center" key={index}>
                                {row[key].map((item1, index1) => {
                                  const icon =
                                    item1.is_trial === "Y" ? (
                                      <img src="/img/sprout.png"></img>
                                    ) : null;
                                  return (
                                    <Chip
                                      icon={icon}
                                      key={index1}
                                      sx={{ mr: 1, mb: 1, fontSize: 11 }}
                                      onClick={() =>
                                        onChipClick(item1.seq, item1.pt_type)
                                      }
                                      label={
                                        item1.name + " (" + item1.state + ")"
                                      }
                                      style={{
                                        backgroundColor:
                                          item1.pt_type === "GX"
                                            ? "rgba(55,198,255,0.2)"
                                            : item1.pt_type === "PT_MANAGER"
                                            ? "rgba(255,160,122,0.2)"
                                            : "rgba(124,252,0,0.2)",
                                      }}
                                    ></Chip>
                                  );
                                })}
                              </TableCell>
                            )
                        )}
                      </TableRow>
                    );
                  })}

                  {rows.length === 0 && (
                    <TableRow>
                      <TableCell colSpan="6" sx={{ width: 140 }} align="center">
                        NO DATA
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>

          <Box sx={{ pt: 10 }}></Box>

          {/* 수업추가 팝업 */}
          <Dialog
            open={showClassAdd}
            fullWidth={true}
            maxWidth="sm"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>수업추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseClassAdd}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ReservationClassAdd
              tcidParent={tcid}
              tdate={tdate}
              login={login}
              onClose={onCloseClassAdd}
            ></ReservationClassAdd>
          </Dialog>

          {/* 수업수정 팝업 */}
          <Dialog
            open={showClassEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>수업수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseClassEdit}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ReservationClassEdit
              login={login}
              seq={seq}
              tcidParent={tcid}
              setTcidParent={setTcid}
              onClose={onCloseClassEdit}
            ></ReservationClassEdit>
          </Dialog>

          {/* 예약추가 팝업 */}
          <Dialog
            open={showAdd}
            fullWidth={true}
            maxWidth="md"
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>예약추가</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseAddPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ReservationAdd
              tcidParent={tcid}
              login={login}
              onClose={onCloseAddPop}
            ></ReservationAdd>
          </Dialog>

          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>예약내용</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <ReservationEdit
              login={login}
              seq={seq}
              onClose={onCloseEditPop}
              ptType={ptType}
              trainers={teacher}
            ></ReservationEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Reservation;
